import React from 'react';
import PropTypes from 'prop-types';
import Button from '@tds/core-button';
import Box from '@tds/core-box';
import Input from '@tds/core-input';
import { Delete } from '@tds/core-interactive-icon';
import Text from '@tds/core-text';
import Notification from '@tds/core-notification';
import { Spacer } from '../../../help/styles';
import Modal from '../../../design/shared/modal';
import { popupStyles } from './styles';

const Promotions = ({ promotions, setPromotions }) => {
  const [showModal, setShowModal] = React.useState(false);
  const [promotionCode, setPromotionCode] = React.useState('');
  const [validationCode, setvalidationCode] = React.useState('');
  const [validationError, setValidationError] = React.useState('');

  const isAddAllowed = promotions.length < 8;

  const openModal = () => {
    if (isAddAllowed) {
      setShowModal(true);
    }
  };

  const closeModal = () => {
    setShowModal(false);
  };

  const resetFields = () => {
    setPromotionCode('');
    setvalidationCode('');
  };

  const addPromotion = () => {
    setPromotions([...promotions, { promotionCode, validationCode }]);
    resetFields();
    closeModal();
  };

  const areFieldsValid = () => {
    if (promotionCode) {
      setValidationError('');
      return true;
    }
    setValidationError('Please enter promotion code to continue');
    return false;
  };

  const onAdd = () => {
    if (areFieldsValid()) {
      addPromotion();
    }
  };

  const onDelete = index => {
    setPromotions([
      ...promotions.slice(0, index),
      ...promotions.slice(index + 1)
    ]);
  };

  return (
    <div className="table-responsive">
      {!!promotions.length && (
        <table className="table table-bordered table-hover">
          <thead style={{ backgroundColor: '#f2f2f2' }}>
            <tr>
              <th scope="col">Promotion code</th>
              <th scope="col">Validation code</th>
              <th>Remove</th>
            </tr>
          </thead>
          {promotions.map((promotion, index) => (
            <tbody key={promotion.promotionCode}>
              <tr>
                <td>{promotion.promotionCode}</td>
                <td>{promotion.validationCode || '-'}</td>
                <td>
                  <Delete onClick={() => onDelete(index)} a11yText="Delete" />
                </td>
              </tr>
            </tbody>
          ))}
        </table>
      )}
      <Box between={4}>
        {!isAddAllowed && (
          <Notification variant="warning" copy="en">
            <Text bold>
              8/8 promotions added, delete a promotion to add another.
            </Text>
          </Notification>
        )}
        <Button onClick={openModal}>Add Promotion</Button>
      </Box>
      <Modal
        open={showModal}
        setOpen={closeModal}
        customStyles={popupStyles}
        header="Add Promotion"
      >
        <Box between={4}>
          {validationError && (
            <Notification variant="error" copy="en">
              <Text bold>{validationError}</Text>
            </Notification>
          )}
          <Input
            id="promotionCode"
            label="Promotion Code*"
            value={promotionCode}
            onChange={e => {
              setPromotionCode(e.target.value);
            }}
          />
          <Input
            id="accessoryPrice"
            label="Validation code (Leave blank if not applicable)"
            value={validationCode}
            onChange={e => {
              setvalidationCode(e.target.value);
            }}
          />
          <Button onClick={onAdd}>Add</Button>
        </Box>
      </Modal>
      <Spacer />
    </div>
  );
};

Promotions.propTypes = {
  promotions: PropTypes.arrayOf({
    promotionCode: PropTypes.string,
    validationCode: PropTypes.string
  }).isRequired,
  setPromotions: PropTypes.func.isRequired
};

export default Promotions;
